import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let user_id = useDataValue({
    context: 'global',
    path: 'user.id',
    viewPath: props.viewPath,
  })
  let current_location_xid = useDataValue({
    context: 'global',
    path: 'current_location.xid',
    viewPath: props.viewPath,
  })

  return {
    variables: { current_location_xid, user_id },
    requestPolicy: 'network-only',
  }
}
